<script>
    import Stepper from "../../Stepper/Stepper.svelte";
    import StepperNavigator from "../../Stepper/StepperNavigator.svelte";
    import { sgettext } from "../../../i18n.js";

    export let branch = 0;
    export let createActivity = false;

    let isValid = true;
    let errors = null;
    let currentStep = 1;
    let createActivityBlock;

    let steps = [
        {
            order: 1,
            label: sgettext("$$CREATE_ACTIVITY$$"),
            done: false,
            isValid: false,
        },
        {
            order: 2,
            label: sgettext("$$ASSIGN_ACTIONS$$"),
            done: false,
            isValid: false,
        },
        {
            order: 3,
            label: sgettext("$$GET_APM_DATA$$"),
            done: false,
            isValid: false,
        },
    ];

    let finalStep = 3;

    $: if (branch > 0 && createActivity) {
        currentStep = 2;
        createActivityBlock = document.getElementById("create_activity");
        createActivityBlock.style.display = "none";
    }
</script>

<Stepper {steps} bind:currentStep />

{#if currentStep == 2}
    <div>
        <h3>{sgettext("$$ASSIGN_ACTIONS$$")}</h3>
    </div>
{/if}
